module.exports = __webpack_public_path__ + "static/img/icon_delete_nor@2x.b3328215.png";